<lib-demande-hospi [configuration]="configuration"></lib-demande-hospi>
